import React, { Ref, HTMLAttributes } from 'react';
import { cx } from '@emotion/css';
import * as styles from './styles';

export type Props = HTMLAttributes<HTMLUListElement> & {
  variant?: 'disc';
};

const Container: React.FC<Props & { innerRef: Ref<HTMLUListElement> }> = ({
  className,
  innerRef,
  variant = 'disc',
  ...rest
}) => (
  <ul
    className={cx(className, { disc: styles.disc }[variant])}
    ref={innerRef}
    {...rest}
  />
);

export default React.forwardRef<HTMLUListElement, Props>((props, ref) => (
  <Container innerRef={ref} {...props} />
));
